export default "__VITE_ASSET__DHVcSeWf__"